import React from "react"
import PropTypes from "prop-types"

import { Link, Image, Wrapper, Tag, Info, Title, Name, Author } from "./styled"

const PostItem = ({
  slug,
  background,
  imageDescription,
  category,
  title,
  author,
}) => (
  <Wrapper>
    <Link href={slug}>
      <Image src={`/assets/img/description/${imageDescription}`} />
      <Tag background={background}>{category}</Tag>
      <Info>
        <Title>{title}</Title>
        <Author>
          por <Name>{author}</Name>
        </Author>
      </Info>
    </Link>
  </Wrapper>
)

PostItem.propTypes = {
  slug: PropTypes.string.isRequired,
  background: PropTypes.string,
  category: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
}

export default PostItem
